<template>
    <div class="modal fade" tabindex="-1" role="dialog" id="create-price-increase-modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <form @submit.prevent="submit">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                &times;
                            </span>
                        </button>

                        <h4 class="modal-title">
                            Increase Price
                        </h4>
                    </div>

                    <div class="modal-body">
                        <select-form-group
                                v-model="data.method"
                                name="method"
                                label="Method"
                                :error="getError('method')"
                                :options="[{value: 'percentage', label: 'Percentage'}, {value: 'absolute', label: 'Absolute'}]"
                        ></select-form-group>

                        <text-form-group
                                v-model="data.amount"
                                name="amount"
                                label="Amount"
                                :error="getError('amount')"
                        ></text-form-group>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">
                            Close
                        </button>

                        <button type="submit" class="btn btn-black">
                            <i class="fa fa-save"></i> Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import notify from '@/notify'
    import Errors from '@/mixins/Errors'
    import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
    import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

    export default {
        components: {SelectFormGroup, TextFormGroup},

        mixins: [Errors],

        props: {
            subscriptionType: {
                required: true
            }
        },

        data() {
            return {
                data: {}
            }
        },

        mounted() {
            this.listenForClose()
        },

        methods: {
            listenForClose() {
                $(this.$el).on('hidden.bs.modal', this.reset)
            },

            submit() {
                http.post('/api/v2/subscription-types/' + this.subscriptionType.id + '/price-increases', this.data)
                    .then(response => {
                        this.$emit('created', response.data.data)

                        notify.success('The price was increased')

                        $(this.$el).modal('hide')
                    })
                    .catch(error => {
                        if (error.response.status === 400) {
                            return notify.error(error.response.data.message)
                        }

                        throw error
                    })
                    .catch(this.catchValidationErrors)
            },

            reset() {
                this.errors = {}

                this.data = {}
            }
        }
    }
</script>
